module.exports = __webpack_public_path__ + "img/112011.34fbe10d.png";